import React, { useState } from "react";
import "./SearchBar.css";
import { AiOutlineClose } from "react-icons/ai";
import searchIcon from "../../../assets/icons/search.png";
import menuIcon from "../../../assets/icons/menu.png";

export default function SearchBar({ onMenuClick }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="search-container">
      {/* Menu button - visible on mobile only via CSS */}
      <button className="menu-inside" onClick={onMenuClick}>
        <img src={menuIcon} alt="Menu" className="menu-icon" />
      </button>

      <input
        type="text"
        className="search-input"
        placeholder="Search gate pass with ID or Name"
      />

      <button className="search-btn" onClick={() => setIsOpen((prev) => !prev)}>
        {isOpen ? (
          <AiOutlineClose className="close-icon" size={16} />
        ) : (
          <img src={searchIcon} alt="Search" className="search-icon" />
        )}
      </button>

      {isOpen && (
        <div className="search-popup">
          <div className="form-row">
            <label>Name</label>
            <input type="text" />
          </div>

          <div className="form-row">
            <label>ID</label>
            <input type="text" />
          </div>

          <div className="form-row">
            <label>Type</label>
            <select>
              <option>Nothing selected</option>
              <option>Type 1</option>
            </select>
          </div>

          <div className="form-row">
            <label>Created By</label>
            <select>
              <option>Nothing selected</option>
              <option>User 1</option>
            </select>
          </div>

          <div className="form-row">
            <label>Created On</label>
            <div className="date-row">
              <span>From</span>
              <input type="date" />
              <span>to</span>
              <input type="date" />
            </div>
          </div>

          <div className="form-row">
            <label>Status</label>
            <div className="status-buttons">
              <button>All</button>
              <button>Pending</button>
              <button>Approved</button>
              <button>Rejected</button>
            </div>
          </div>

          <div className="popup-footer">
            <button className="clear-btn">Clear all filters</button>
            <button className="search-btn-popup">Search</button>
          </div>
        </div>
      )}
    </div>
  );
}
